<template>
  <NavigationBar />
  <DotAnimation />
  <div class="content">
    <router-view></router-view>
  </div>
</template>

<script>
import DotAnimation from './components/Dot.vue'
import NavigationBar from './components/Navbar.vue'

export default {
  name: 'App',
  components: {
    DotAnimation,
    NavigationBar
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  width: 100%;
  font-family: Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}

#app {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}

.content {
  margin-top: 120px;
  flex: 1;
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 3;
}
</style>
